import { Card } from '@acs/ui';
import type { BusinessDoc } from '../../shared/api/converters.js';
import { useI18n } from '../../i18n/index.js';
import { BillingCard } from './BillingCard.js';
import { CheckoutConfirming } from './CheckoutConfirming.js';
import { PrepaidBilling } from './PrepaidBilling.js';
import { UsageCard } from './UsageCard.js';
import { useCheckoutReturn } from './useCheckoutReturn.js';

/**
 * Settings › Billing (doc 42 §4). One menu entry for everything money:
 * a `legacy` business keeps its monthly-allowance cards exactly as before; a
 * `prepaid_v1` business gets balance, minutes and auto top-up.
 *
 * It is also where a business past setup subscribes (a lapsed or cancelled
 * subscription), and where Stripe Checkout returns it to.
 */
export function BillingSection({ business }: { business: BusinessDoc }) {
  const { t } = useI18n();
  const ret = useCheckoutReturn(business);
  const confirming = ret.confirming && (
    <Card title={t('billing.done.pending.title')}>
      <CheckoutConfirming ret={ret} />
    </Card>
  );
  if (business.billingSummary.mode === 'prepaid_v1') {
    return (
      <>
        {confirming}
        <PrepaidBilling business={business} canceled={ret.canceled} confirming={ret.confirming} />
      </>
    );
  }
  return (
    <>
      {confirming}
      <UsageCard business={business} />
      <BillingCard business={business} canceled={ret.canceled} confirming={ret.confirming} />
    </>
  );
}
